module.exports = __webpack_public_path__ + "static/media/customer.66a0a2f0.jpeg";